import React from 'react';

const AddCol = ({ ...attrs }) => (
  <svg viewBox="0 0 25 25" {...attrs}>
    <path d="m13.836 11.805v1.5q0 0.312-0.219 0.531t-0.531 0.219h-3.25v3.25q0 0.312-0.219 0.531t-0.531 0.219h-1.5q-0.312 0-0.531-0.219t-0.219-0.531v-3.25h-3.25q-0.312 0-0.531-0.219t-0.219-0.531v-1.5q0-0.312 0.219-0.531t0.531-0.219h3.25v-3.25q0-0.312 0.219-0.531t0.531-0.219h1.5q0.312 0 0.531 0.219t0.219 0.531v3.25h3.25q0.312 0 0.531 0.219t0.219 0.531z" />
    <path d="m16.654 22.96a0.88112 0.90025 89.702 0 0 0.90227 0.87676l4.5774-0.02381a0.88112 0.90025 89.702 0 0 0.897 -0.886l-0.108-20.801a0.88112 0.90025 89.702 0 0 -0.905 -0.8766l-4.5774 0.023807a0.88112 0.90025 89.702 0 0 -0.894 0.8861l0.10818 20.8zm1.7937-0.89078-0.09901-19.038 2.7762-0.01444 0.09901 19.038-2.7762 0.01444z" />
  </svg>
);

export default AddCol;
